module.exports = __webpack_public_path__ + "img/ArrowRight-icon.b0752040.svg";